import { call, put, takeEvery } from 'redux-saga/effects';
import RecommendationApi from 'apis/supremeGolfApi/RecommendationApi';

import RecommendationActions, { RecommendationTypes } from 'reducers/recommendation';
import FlowActions from 'reducers/flow';

export function* getRecommendedCourses({ courseId, date, limit }) {
  try {
    const data = yield call(RecommendationApi.getRecommendedCourses, { courseId, date, limit });
    const { nearbyCourses, coursesWithHotDeals } = data;
    yield put(RecommendationActions.getRecommendedCoursesDone(nearbyCourses, coursesWithHotDeals));
  } catch (error) {
    const errorMessage = error?.response?.data?.message || error?.message;
    yield put(RecommendationActions.getRecommendedCoursesError(errorMessage));
  }
}

export function* getRecommendedTeeTimes({ teeTimeId, qty, limit }) {
  try {
    const data = yield call(RecommendationApi.getRecommendedTeeTimes, { teeTimeId, qty, limit });
    yield put(FlowActions.setfProvider({ authToken: data.authToken }));

    yield put(RecommendationActions.getRecommendedTeeTimesDone(data.teeTimes));
  } catch (error) {
    const errorMessage = error?.response?.data?.message || error?.message;
    yield put(RecommendationActions.getRecommendedTeeTimesError(errorMessage));
  }
}

function* getRecommendedCoursesWatcher() {
  yield takeEvery(RecommendationTypes.GET_RECOMMENDED_COURSES, getRecommendedCourses);
}

function* getRecommendedTeeTimesWatcher() {
  yield takeEvery(RecommendationTypes.GET_RECOMMENDED_TEE_TIMES, getRecommendedTeeTimes);
}

export default [
  getRecommendedCoursesWatcher,
  getRecommendedTeeTimesWatcher,
];
